import { render, staticRenderFns } from "./stands-list.vue?vue&type=template&id=25d64c74&"
import script from "./stands-list.vue?vue&type=script&lang=js&"
export * from "./stands-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports